import { SvgIcon, SvgIconProps } from '@mui/material';
import { FC } from 'react';

export const CheckmarkIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 10 8"
    fill="none"
    sx={{ width: 14, height: 11 }}
    {...props}
  >
    <path d="M1 3L4 6L9 1" stroke="white" strokeWidth="2" fill="none" />
  </SvgIcon>
);
